import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { QueryCondition } from '../../entity/querycondition';
import { InputGroupValue } from "../../entity/conditionvalue/inputgroup";

export class InputGroupHandler implements IQueryConditionHandler {
    convert(qc: QueryCondition) {
        const igv = (qc.value as InputGroupValue);
        const arr = [];
        if(igv.textValue === undefined || igv.textValue === null || igv.textValue.length == 0 ){
            return [];
        }
        else if (igv.isInputText) {
            arr.push({
                'FilterField': qc.fieldCode,
                'Compare': CompareType.Like,
                'Value': igv.textValue,
                'Relation': RelationType.And,
                'Expresstype': ValueType.Value
            });
            return arr;
        }
        else {
            igv.getOriginalValue().split(',').forEach(itemValue => {
                itemValue && arr.push({
                    'FilterField': qc.fieldCode,
                    'Compare': CompareType.Equal,
                    'Value': itemValue,
                    'Relation': RelationType.Or,
                    'Expresstype': ValueType.Value
                });
            });
            if (arr.length > 0) {
                arr[0]['Lbracket'] = '(';
                arr[arr.length - 1]['Rbracket'] = ')';
                arr[arr.length - 1]['Relation'] = RelationType.And;
                return arr;
            } else {
                return [];
            }
        }
    }
}